export default "__VITE_PUBLIC_ASSET__ee91564c__"